import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import type * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import type { FindAllDeliveryOptionsQuery } from "@/libs/generated/operations";
import { DeleteOptionPopover } from "./DeleteOptionPopover";

type OriginalDeliveryOptionRecord = FindAllDeliveryOptionsQuery["findAllDeliveryOptions"][number];

type DeliveryOptionRecord = Omit<OriginalDeliveryOptionRecord, "requiresPhoto"> & {
  requiresFile: boolean;
  fileType: "IMAGE" | "PDF" | null;
};

interface RowActionsProps {
  record: DeliveryOptionRecord;
  onEdit: (record: DeliveryOptionRecord) => void;
}

export function RowActions({ record, onEdit }: RowActionsProps) {
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const handleEdit = () => onEdit(record);
  const handleDeleteClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchor(e.currentTarget);
  };

  return (
    <Stack direction="row" spacing={0.5}>
      <IconButton size="small" onClick={handleEdit}>
        <Edit fontSize="small" />
      </IconButton>
      <IconButton size="small" color="error" onClick={handleDeleteClick}>
        <Delete fontSize="small" />
      </IconButton>
      <DeleteOptionPopover
        anchorEl={anchor}
        record={record}
        onClose={() => setAnchor(null)}
        onEdit={(r) => navigate(`/admin/options/${r.id}/edit`)}
      />
    </Stack>
  );
}
